import * as clientDb from "../db/clientDb";

/** Avoid mixed-content warnings when the page is served over HTTPS. */
export function secureImageSrc(url: string | null | undefined): string | null {
    if (!url) return null;
    if (url.startsWith("http://")) return `https://${url.slice(7)}`;
    return url;
}

/** Same-origin image URL — local uploads pass through, external URLs use the server proxy. */
export function resolveImageSrc(path: string | null | undefined): string | null {
    if (!path) return null;
    if (path.startsWith("blob:")) return path;
    if (path.startsWith("/")) return path;
    if (path.startsWith("/api/image-proxy")) return path;

    const secure = secureImageSrc(path);
    if (!secure) return null;
    return `/api/image-proxy?url=${encodeURIComponent(secure)}`;
}

/**
 * Async image resolver — checks the IndexedDB image cache first (for offline support),
 * then falls back to the network path. Returns a blob URL if cached, otherwise the
 * resolved network path.
 */
export async function resolveCachedImageSrc(path: string | null | undefined): Promise<string | null> {
    if (!path) return null;
    if (path.startsWith("blob:")) return path;
    const resolved = resolveImageSrc(path);
    if (!resolved) return null;
    try {
        const cached = await clientDb.getCachedImage(resolved);
        if (cached) return URL.createObjectURL(cached);
    } catch { /* cache miss */ }
    return resolved;
}
